module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'jobs',
        preventClearOnCancel: true,
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_jobs': true,
        },
    },
}